var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"type"},[_c('div',{staticClass:"pr-3 d-flex"},_vm._l((_vm.type),function(item,index){return _c('div',{key:index,class:{ active: item.id == _vm.$store.state.currentType.id },on:{"click":function($event){return _vm.selectType(index, item)}}},[_c('p',[_vm._v(_vm._s(item.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }